export default __webpack_public_path__ + "static/media/Expresiones-otros.eed6bc30.svg";